import type { JSX } from "solid-js";
import type { FormApi } from "./createForm";

export type FormProps<T> = {
  form: FormApi<T>;
  children: (input: {
    value: FormApi<T>["getValue"];
    updateValue: FormApi<T>["updateValue"];
    error: FormApi<T>["getError"];
  }) => JSX.Element;
  class?: string;
};
export const Form = <T,>(props: FormProps<T>) => (
  <form
    id={props.form.id}
    onSubmit={(e) => {
      void props.form.submit();
      e.preventDefault();
    }}
    class={props.class}
  >
    {props.children({
      value: props.form.getValue,
      updateValue: props.form.updateValue,
      error: props.form.getError,
    })}
    {/* Required for submitting a form with multiple fields */}
    <button type="submit" hidden />
  </form>
);
